import { BackButton } from '~/components';
import { SubmitButton } from './SubmitButton';
import { StyledApplicationButtonsWrapper } from './styles';
import { ApplicationButtonsProps } from './types';

export const ApplicationButtons = ({
    backContent,
    backTo,
    continueContent,
    loading,
    hasError,
}: ApplicationButtonsProps) => {
    return (
        <StyledApplicationButtonsWrapper>
            {!hasError && <SubmitButton submitting={loading}>{continueContent || 'Next'}</SubmitButton>}{' '}
            {backTo && <BackButton route={backTo}>{backContent || 'Back'}</BackButton>}
        </StyledApplicationButtonsWrapper>
    );
};
